export class BookletReviewsLight {
  guestReviewComment: string;
  guestReviewRate: number;
}
